import { render, staticRenderFns } from "./Extended.vue?vue&type=template&id=6d534712&"
import script from "./Extended.vue?vue&type=script&lang=js&"
export * from "./Extended.vue?vue&type=script&lang=js&"
import style0 from "./Extended.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports